import { useEffect, useState } from "react";
import base from "../middlewares/interceptors";
import { getUserRolesUrl } from "../services/constants";

interface IUseFetchUserRoles {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string | number | null | undefined;
}

const useFetchUserRoles = ({ setIsLoading, userId }: IUseFetchUserRoles) => {
  const [userRoles, setUserRoles] = useState<number[]>([]);

  useEffect(() => {
    if (!userId) {
      setUserRoles([]);
      return;
    }

    const fetchUserRoles = async () => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      try {
        const response = await base.get(
          `${getUserRolesUrl}/${userId}/roles?include_inactive=false`
        );
        setUserRoles(response.data || []);
      } catch (err) {
        console.error("Error fetching user roles:", err);
        setUserRoles([]);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

    fetchUserRoles();
  }, [userId, setIsLoading]);

  return [userRoles, setUserRoles] as const;
};

export default useFetchUserRoles;
